import { InstanceManager, NewInstanceScreen } from 'feature/editorial-dash/question-topic-manager';
import { component, demoFile } from 'system/demo';

demoFile('feature/editorial-dash/question-topic-manager');

const instanceList = [
    {key: 'a', name: 'Question A', from: 'u', time: Date.now()},
    {key: 'b', name: 'Question B', from: 'u', time: Date.now()}
];

const baseConfig = {
    instanceTopLeftWidgets: [],
    instanceTopRightWidgets: [],
    instanceBodyWidgets: [],
    instanceBottomLeftWidgets: [],
    instanceBottomRightWidgets: [],
    instanceFilters: [],
    newInstanceWidgets: [],
    newInstanceCreateBlockers: [],
    newInstanceCreators: [],
    newInstancePostCreateTriggers: []
};

component('InstanceManager', InstanceManager, {
    args: {titleLabel: 'Questions', instanceList, structureKey: 'question'},
    config: baseConfig
});
component('NewInstanceScreen', NewInstanceScreen, {
    args: {structureKey: 'question'},
    config: baseConfig
});
